export enum BazaarvoiceReviewSortKey {
  Relevancy = 'Relevancy',
  SubmissionTimeDesc = 'SubmissionTimeDesc',
  RatingDesc = 'RatingDesc',
  RatingAsc = 'RatingAsc',
}

export type CustomerReview = {
  id: string
  title: string
  text: string
  author: string
  date: Date
  recommended: boolean | null
  rating: number
  helpfulCount: number
  notHelpfulCount: number
}

export type RatingDistributionItem = {
  rating: number
  count: number
}

export type ReviewData = {
  reviews: CustomerReview[]
  total: number
  totalPages: number
  averageRating: number
  ratingDistribution: RatingDistributionItem[]
}

export type BazaarvoiceFormFieldOption = {
  Label: string
  Value: string
  Selected?: boolean
}

export type BazaarvoiceFormField = {
  Id: string
  Type: string
  Label?: string | null
  Required?: boolean
  MinLength?: number | null
  MaxLength?: number | null
  MinValue?: number | null
  MaxValue?: number | null
  Value?: string | null
  Default?: string | null
  Options?: BazaarvoiceFormFieldOption[]
}

// A reference to a field or group within the form layout (used by `Form` and by
// a group's `SubElements`).
export type BazaarvoiceFormElement = {
  Type: string
  Id: string
}

export type BazaarvoiceFormGroup = {
  Id: string
  Type: string
  Label?: string | null
  Required?: boolean
  SubElements: BazaarvoiceFormElement[]
}

// The field/group definitions plus their display ordering.
export type BazaarvoiceReviewFormData = {
  Fields: Record<string, BazaarvoiceFormField>
  Groups: Record<string, BazaarvoiceFormGroup>
  FieldsOrder: string[]
  GroupsOrder: string[]
}

// The trimmed review form returned by BazaarvoiceService.getReviewForm — the
// required fields for a product (from the submitreview form definition) plus
// their display order (from the initiateSubmit form).
export type ReviewForm = {
  fields: Record<string, BazaarvoiceFormField>
  fieldsOrder: string[]
}

// Preview of the review being built, echoed back in the form response.
export type BazaarvoiceReviewFormReview = {
  SendEmailAlertWhenCommented: boolean
  Rating: number
  SubmissionTime: string | null
  ReviewText: string | null
  SubmissionId: string | null
  Title: string | null
  IsRecommended: boolean | null
  TypicalHoursToPost: number | null
  Id: string | null
  SendEmailAlertWhenPublished: boolean
}

// Response of GET /data/submitreview.json with no submit Action — describes the
// form configured for this product (which fields exist, which are required, and
// any hidden/system fields that must be echoed back on submission).
export type BazaarvoiceReviewFormResponse = {
  Locale: string
  Errors: any[]
  Form: BazaarvoiceFormElement[]
  FormErrors?: Record<string, unknown>
  SubmissionId?: string | null
  Data: BazaarvoiceReviewFormData
  TypicalHoursToPost?: number
  Review?: BazaarvoiceReviewFormReview
  AuthorSubmissionToken?: string | null
  HasErrors: boolean
}
